<template>
    <div>

        <v-radio-group label="Choix de la vague de départ" v-model="course.vague_selected">
            <v-radio class="radio_vagues" color="primary-dark" hide-details
                v-for="(vague, index_vague) in course.vagues.list" :key="index_vague" :value="vague.id"
                :disabled="!is_vague_available(vague)">
                <template v-slot:label>
                    <div> {{ get_label_vague(vague) }}</div>
                </template>
            </v-radio>
        </v-radio-group>
    </div>

</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

export default {
    props: ["item"],
    name: 'RadioSelectionVague',
    data() {
        return {
            // Your component data goes here
        };
    },
    methods: {
        get_label_vague(vague) {
            let label = '';
            label += vague.nom;
            if (vague.places_restantes > 0 && vague.places_restantes < 1000) {
                label += ` (${vague.places_restantes} places restantes)`;
            }
            else if (vague.places_restantes <= 0) {
                label += ' (complet)';
            }
            return label;
        },
        is_vague_available(vague) {
            return vague.is_available(this.mainStore.inscription_vip);
        }
    },
    computed: {
        ...mapStores(useMainStore),
        course() {
            return this.item;
        },
        // Your computed properties go here
    },
    mounted() {
        // Your mounted lifecycle hook goes here
    }
};
</script>

<style scoped>
/* Your component styles go here */
</style>